<template>
    <CContainer class="d-flex  min-vh-100" style="background-color: #F8F8F8;">
        <CRow  style="margin-right: auto;margin-left: auto">
            <CCol class="login-back">
                    <CCard class="p-4 ">
                        <CCardBody style="padding: 10px">
                            <CForm v-on:keyup.enter="login()">
                               <div class="content-center " style="    display: block;">
                                   <img src="/img/login_logo2.svg" style="width: 50px;height: auto;" />
                                   <h4>Hotel Management</h4>

                               </div>

                                <CInput
                                        :label="$t('userName')"
                                        style="margin-top: 20px"

                                        autocomplete="username email"
                                        v-model="user"

                                />

                                <CInput
                                        :label="$t('password')"
                                        type="password"
                                        v-model="pass"
                                        style="margin-top: 20px"
                                        autocomplete="curent-password"
                                />

                                <CRow>
                                    <CCol col="12" class="text-center"
                                          style="margin-top: 20px"
                                    >


                                        <CButton color="danger" style="width: 100%" v-on:click="login()" class="px-4">
                                            <CSpinner v-if="loading" size="sm"/>
                                            {{ $t('login') }}
                                        </CButton>
<!--                                        <CRow class="mt-3">-->

<!--                                            <label @click="forgot_password_modal=true">{{ $t('forgotPassword') }}</label>-->
<!--                                        </CRow>-->
                                    </CCol>
                                    <CCol col="6" class="text-right">
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCardBody>
                    </CCard>
            </CCol>
        </CRow>
        <Modals ref="modal"/>
        <CModal
                :title="$t('forgotPassword')"
                color="danger"
                :show.sync="forgot_password_modal"
        >
           <CRow>
               <CCol>
                   <CInput
                       :placeholder="$t('mobileNoOrEmail')"
                       v-model="forgot_password_number"
                       />
               </CCol>
           </CRow>
            <template #footer>
                <CButton @click="forgot_password_modal = false,forgot_password()" color="dark">{{$t('ok')}}</CButton>
                <CButton @click="forgot_password_modal = false" color="dark">{{$t('cancel')}}</CButton>
            </template>
        </CModal>

    </CContainer>

</template>


<script>
    import axios from "axios";
    import Modals from "../panel/includes/Modals";

    export default {
        name: 'Login',
        data() {
            return {
                user: '',
                pass: '',
                forgot_password_modal:false,
                forgot_password_number: '',
                loading: false,
            }
        },
        components: {
            Modals
        },
        mounted() {
            // var json = {
            //
            // }
            // var keys = [];
            // for(var k in json) keys.push(k);
            // for(var ka=0; ka< keys.length;ka++){
            //   var str = json[keys[ka]];
            //   const arr = str.split(" ");
            //
            //   for (var i = 0; i < arr.length; i++) {
            //     arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
            //
            //   }
            //   const str2 = arr.join(" ");
            //   json[keys[ka]] = str2;
            //
            //
            // }
            // console.log(JSON.stringify(json))

        },
        methods: {

            goRegister() {
                this.$router.push({path: '/register'});
            },
            login() {

                let self = this;
                self.loading = true;

                let url = "tokenStf";
                const formData = new FormData();

                formData.append('username', this.user);
                formData.append('password', this.pass);

                delete axios.defaults.headers.post["Authorization"];
                axios.post(url, formData, {}).then((res) => {
                    self.loading = false;

                    // console.log(res.headers.value('token'));
// res.headers.value('token');
                    if (res.data.statusCode != 0) {
                        self.$refs.modal.show_danger_modal(this.$t("error"), res.data.message);
                        console.log("not success");
                    } else {
                        console.log("last url " + localStorage.getItem('last_url'));


                        localStorage.setItem('hotel_id', res.data.data.hotelId);
                        localStorage.setItem('hotel_name', res.data.data.hotelName);
                        localStorage.setItem('user_name', res.data.data.userName);
                        localStorage.setItem('image', res.data.data.imgUrl);
                        localStorage.setItem('user_id', res.data.data.userId);
                        localStorage.setItem('token', res.data.data.tokenText);
                        localStorage.setItem("app_logo", localStorage.getItem("api_address") + res.data.data.logo)
                        localStorage.setItem('branchName', res.data.data.branchName);
                        localStorage.setItem('branchCode', res.data.data.branchCode);
                        localStorage.setItem('branchId', res.data.data.branchId);
                        localStorage.setItem('businessName', res.data.data.businessName);
                        localStorage.setItem('givenName', res.data.data.givenName);
                        localStorage.setItem('surName', res.data.data.surName);

                        // if (localStorage.getItem('last_url') == null) {
                        self.get_languages()
                        // } else {
                        //     self.$router.push({path: localStorage.getItem('last_url')});
                        // }

                    }

                    // Modals.show_danger_modal('sss',"sdsddd",[]);


                }).catch(function (error) {
                    self.loading = false;

                });

            },
            get_languages(){

                let self = this;
                self.loading = true;

                let url = "/Lang/GetHotelsLtxts";
                const formData = new FormData();
                axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token');

                formData.append('id',localStorage.getItem('hotel_id'));

                axios.post(url, formData, {}).then((res) => {

                    var languages = []
                    res.data.data.forEach(function (val) {
                        languages.push(val.lngId)
                    })
                    localStorage.setItem("languages",JSON.stringify(languages));
self.get_hotel_info()
                }).catch(function (error) {
                    self.loading = false;

                });

            },
            get_hotel_info() {

                var self = this;

                const formData = new FormData();

                var hotel_id = localStorage.getItem("hotel_id");
                formData.append("hId", hotel_id)

                axios.post('Hotel/GetHotelById ', formData, {}).then(function (response) {

                    var content_data = response.data;
                    if (content_data.statusCode == 0) {
                        localStorage.setItem("currencySymbol",content_data.data.currencySymbol )
                        self.$router.push({path: '/dashboard'});

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("error"), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            forgot_password() {
                if (this.user == "") {
                    this.$refs.modal.show_danger_modal(this.$t("error"), this.$t('insertMobile'));
                    return;
                }
                let self = this;
                self.loading = true;
                const formData = new FormData();
if(this.forgot_password_number.includes("@")){
    formData.append('mobileNo', "");
    formData.append('eMail', this.forgot_password_number);
}else{
    formData.append('mobileNo', this.forgot_password_number);
    formData.append('eMail', "");
}
                delete axios.defaults.headers.post["Authorization"];
                axios.post("ForgotPassword", formData, {}).then((res) => {
                    self.loading = false;

                    // console.log(res.headers.value('token'));
// res.headers.value('token');
                    if (res.data.statusCode != 0) {
                        this.$refs.modal.show_danger_modal(this.$t("error"), res.data.message);
                    } else {
                        this.$refs.modal.show_api_response_modals(this.$t("error"), res);
                    }

                    // Modals.show_danger_modal('sss',"sdsddd",[]);


                }).catch(function (error) {
                    self.loading = false;

                });

            }
        }
    }


</script>
<style>
    .login-back{
        background: url(/img/login_background.svg);
        background-size: contain;
height: fit-content;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: 35px;
        padding: 35px;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
